import { render, staticRenderFns } from "./ComposeNote.vue?vue&type=template&id=6e60b3e7&scoped=true"
import script from "./ComposeNote.vue?vue&type=script&lang=js"
export * from "./ComposeNote.vue?vue&type=script&lang=js"
import style0 from "./ComposeNote.vue?vue&type=style&index=0&id=6e60b3e7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e60b3e7",
  null
  
)

export default component.exports